import { render } from "./DeleteCategoryModal.vue?vue&type=template&id=2250ee2a"
import script from "./DeleteCategoryModal.vue?vue&type=script&lang=js"
export * from "./DeleteCategoryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__